import moment from "moment";

import { OnSchedRest }  from "../OnSchedRest";
import { OnSchedUtils } from "../utils";


export const FindCustomer = (element, payload) => new Promise((resolve, reject) => {
  const { onsched } = element;

  let url = onsched.apiBaseUrl + '/customers?';

  if (payload.id) {
    url = onsched.apiBaseUrl + '/customers/' + payload.id;
  }
  else if (payload.email) {
    url += 'email=' + payload.email;
  }
  else {
    Object.keys(payload).map(k => { url += `${k}=${payload[k]}&` });
  }

  
  OnSchedRest.Get(url, data => {
    OnSchedUtils.CheckErrors({ element, data })
      .then(() => {
        if (payload.id) {
          resolve(data);
        }
        else if (data.data?.length) {
          resolve(data.data[0]);
        }
        else {
          resolve(null)
        }
      })
  });
});

export const CreateCustomer = (element, data) => new Promise((resolve, reject) => {
  const { onsched } = element;

  let url = onsched.apiBaseUrl + '/customers/';

  let payload = {...data, ...element.options.fields};

  if (payload.firstName) {
    payload.firstname = payload.firstName;
    delete payload.firstName;
  }
  
  if (payload.lastName) {
    payload.lastname = payload.lastName;
    delete payload.lastName;
  }

  if (payload.phone) {
    payload.contact = { preferredPhoneType: 'm', mobilePhone: payload.phone };
    delete payload.phone;
  }
  
  OnSchedRest.Post(url, payload, response => OnSchedUtils.CheckErrors({ element, response }).then(resolve));
});

export const UpdateCustomer = (element, payload) => new Promise((resolve, reject) => {
  const { onsched } = element;

  let url = onsched.apiBaseUrl + '/customers/' + payload.id;
  
  OnSchedRest.Put(url, payload, data => OnSchedUtils.CheckErrors({ element, data }).then(resolve));
});